$.fn.randomize = function (selector) {
  var $elems = selector ? $(this).find(selector) : $(this).children(),
    $parents = $elems.parent();

  $parents.each(function () {
    $(this).children(selector).sort(function (childA, childB) {
      // * Prevent last slide from being reordered
      if ($(childB).index() !== $(this).children(selector).length - 1) {
        return Math.round(Math.random()) - 0.5;
      }
    }.bind(this)).detach().appendTo(this);
  });

  return this;
};




$(function () {

  $('a[href$=".pdf"]').attr('target', '_blank');

  if ($('.onepager')) {
    $('.content .desktop-navigation').html($('.header__desktop-navigation').html());
  }


  $('form button[type="submit"]').click(function () {
    var c1 = $('input[name=neuigkeiten]').not(":checked").length;
    var c2 = $('input[name=plaetze]').not(":checked").length;

    if (c1 && c2) {
      $('input[name=neuigkeiten], input[name=plaetze]').prop('required', true);
      $('.checkbox').addClass('parsley-error');
    } else {
      $('input[name=neuigkeiten], input[name=plaetze]').prop('required', false);
      $('.checkbox').removeClass('parsley-error');
    }

    $('.checkbox--wrapper').removeClass('parsley-error-parent');
    $('.checkbox').each(function () {
      if ($(this).hasClass('parsley-error')) {
        $('.checkbox--wrapper').addClass('parsley-error-parent');
      }
    });

  });






  $('.header__home').bind('click', function () {
    playIntro();
  });

  $(window).scroll(function (event) {
    var scroll = $(window).scrollTop();
    if (scroll > 700) {
      $('.topTop').addClass('show');
    } else {
      $('.topTop').removeClass('show');
    }
  });



  $(".topTop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  function playIntro() {
    $('.header__home').addClass('small');
    $('.intro').addClass('hide');
    $('.header__home').unbind('click');

    $('.badge').addClass('show');

    setTimeout(function () {
      $('.intro').css('display', 'none');
      $('.header__home .quote').remove();
      if ($(window).width() >= 920) {
        $('.hiddenHeader').fadeIn();
      }
    }, 2000);

    $('.slideshow').randomize().slick({
      dots: true,
      infinite: true,
      speed: 1500,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000
    });
  }

  $('.slideshow-content').slick({
    dots: true,
    infinite: false,
    speed: 600,
    fade: false,
    autoplay: false,
    accessibility: true
  });

  setTimeout(playIntro, 1500);

  $('.slimmenu').slimmenu({
    resizeWidth: '10000',
    collapserTitle: 'Main Menu',
    animSpeed: 'fast',
    indentChildren: true,
    // childrenIndenter: '&raquo;'
  });

  $('.slimmenu a.current').each(function () {
    $(this).parent().find('>.sub-toggle:first').click();
  });

  $('.header__mobile-navigation  .hamburger').click(function () {
    $(this).toggleClass('is-active');
    $('.slimmenu').toggleClass('is-active');
    $('.header__mobile-navigation').toggleClass('is-active');
    $('.header__home').toggle();
    $('html').toggleClass('nav-is-active');

  });



  $('.header__home .hamburger').click(function () {
    // $('.header__home').hide();
    $('.hiddenHeader').show();
    $('.header__mobile-navigation  .hamburger').click();
  });

  setInterval(function () {
    if ($('h1').height() != undefined) {
      // console.log($('h1').height());
      $('.content--spacer').height($('h1').height());
    }

    if ($(window).width() > 1100) {
      $('.onepager .sidebar').css('paddingTop', $('h1').height() + 40);
    } else {
      $('.onepager .sidebar').css('paddingTop', 15);
    }

    if ($('.content__lead').height() != undefined) {
      // console.log($('h1').height());
      $('.content--spacer').height($('.content__lead').height());
    }
    if ($(window).width() >= 920)
      $('.subnavigation').show();

    $(window).resize(function (event) {
      if ($(window).width() < 920) {
        $('.subnavigation').hide();
      } else {
        $('.subnavigation').show();
      }

    });

  }, 1);

  var scroll = new SmoothScroll('a[href*="#"]', {
    offset: 150,
    speed: 1000
  });

  $('.more--info, .close').click(function () {
    $('.popup__info').toggleClass('show');
    return false;
  });

  $('.scroll__icon').click(function () {
    $("html, body").animate({ scrollTop: $('.content').position().top + 20 }, "slow");
    return false;
  });


  AOS.init({
    once: true,
    easing: 'ease-out-sine',
    offset: -200,
    delay: 600
  });


  if ($('.content__lead').length) {
    //$(".subnavigation > ul").pin({padding:{top:150}});
    stickybits('.desktop-navigation', { stickyBitStickyOffset: 0 });
    console.log('stickybits');
  } else {
    // $(".subnavigation > ul").pin({padding:{top:150}});
  }

});
